import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { createRequestArchivedClientsAction } from 'actions/clientActions';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getAll } from 'store/selectors';
import { ApiDataTypes } from 'api/apiDataTypes';
import ClientsTable from './clientsTable';

function mapStateToProps(state: ClippingPlatformState) {
  return {
    clients: getAll(state.entities.archivedClients),
    allClientsLoaded: state.appStatus.allLoaded[ApiDataTypes.ArchivedClients],
    archived: true,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadAllClients: (c: any) => dispatch(createRequestArchivedClientsAction(c, dispatch)),
  };
}

export const ArchivedClientsTableContainer = connect(mapStateToProps, mapDispatchToProps)(ClientsTable);
